/** Core */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
/** core */
/** Components */
import { TextTemplateComponent } from '@core/components/text-template/text-template.component';
/** Directives */
/** pipes */
/** Services */
/** npm Modules */
/** custom Modules */
/** Mat Modules */
/**** *** *** *** *** *** *** *** *** *** *** *** *** */
const coreModules = [CommonModule];
const matModules: [] = [];
const npmModules: [] = [];
const pipeModules: [] = [];
const moduleComponents = [TextTemplateComponent];
const customModules: [] = [];
const pipeProviders: [] = [];
const sharedServices: [] = [];

@NgModule({
  declarations: [...moduleComponents],
  providers: [...pipeProviders, ...sharedServices],
  imports: [...coreModules, ...matModules, ...customModules, ...npmModules, ...pipeModules],
  exports: [...moduleComponents, ...coreModules, ...matModules, ...customModules, ...npmModules, ...pipeModules],
})
export class TextTemplateModule { }